import React from "react";
import Card from "../../../components/page/Card";
import { AppContext } from "../../../contexts/AppContext";
import CommonButton from "../../../components/buttons/CommonButton";
import { hoje, formataData } from "../../../helpers/mesesHelper";
import PropTypes from "prop-types";

function CertificadoCard({
  togEditarCertificadoModal,
  validade,
  togComprarCertificadoModal,
}) {
  const [diaVencimento, setDiaVencimento] = React.useState("");
  const { session } = React.useContext(AppContext);

  React.useEffect(() => {
    const validadeDate = new Date(validade);
    const diffTime = validadeDate - hoje;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    if (isNaN(diffDays)) {
      setDiaVencimento("-");
    } else if (diffDays > 0) {
      setDiaVencimento(diffDays);
    } else if (diffDays === 0) {
      setDiaVencimento("Vence hoje");
    } else {
      setDiaVencimento("Vencido");
    }
  }, [validade]);

  return (
    <div className="row justify-content-center">
      <div className="col-xl-8">
        <Card margin={0}>
          <div className="row m-4 mt-3">
            <div className="col">
              <span className="font-size-24" style={{ fontWeight: 600 }}>
                Meu certificado e-CNPJ A1
              </span>
            </div>
          </div>
          <div className="row m-4 mt-5">
            <div className="col-md-6">
              <div className="row">
                <div className="col-1">
                  <i className="fas fa-calendar-alt font-size-20 text-orange"></i>
                </div>
                <div className="col">
                  <span className="font-size-16">
                    <strong>Data de vencimento:</strong>
                  </span>
                </div>
              </div>
              <div className="row pt-2">
                <div className="col-1"></div>
                <div className="col">
                  <span className="font-size-14 text-muted">
                    <strong>{validade ? formataData(validade) : "-"}</strong>
                  </span>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <div className="col-1">
                  <i className="fas fa-clock font-size-20 text-orange"></i>
                </div>
                <div className="col">
                  <span className="font-size-16">
                    <strong>Dias para o vencimento:</strong>
                  </span>
                </div>
              </div>
              <div className="row pt-2">
                <div className="col-1"></div>
                <div className="col">
                  <span className="font-size-14 text-muted">
                    <strong>{validade ? diaVencimento : "-"}</strong>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="row justify-content-center pb-2 mt-5">
            {session.codigo ? (
              <div className="col text-center">
                <CommonButton
                  onClick={() => {
                    if (session.codigo === "99") togEditarCertificadoModal();
                    else togComprarCertificadoModal();
                  }}
                  color="orange"
                  style={{ color: "#ffffff", fontSize: "18px" }}
                >
                  {session.codigo === "99"
                    ? "Editar manualmente"
                    : "Renove agora!"}
                </CommonButton>
              </div>
            ) : null}
          </div>
        </Card>
      </div>
    </div>
  );
}

CertificadoCard.propTypes = {
  togEditarCertificadoModal: PropTypes.func.isRequired,
  validade: PropTypes.string.isRequired,
  togComprarCertificadoModal: PropTypes.func.isRequired,
};

export default CertificadoCard;
